import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapTransactionHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Transaction;
    }
}

//# sourceMappingURL=WrapTransactionHelper.js.map
